// features/home/HomeOrLanding.tsx — the "/" branch (1.24.60).
//
// Signed in → the Home feed, exactly as "/" has always behaved for members.
// Signed out → the marketing landing page; the guest feed lives at /feed.
//
// A plain conditional, not a redirect: the canonical marketing URL must BE "/"
// (the sitemap lists it, every backlink points at it), and a redirect would
// flash a URL change and split that equity across two addresses. Safe from a
// landing flash on hard reload because the session store hydrates from
// localStorage synchronously at store creation — isAuthenticated is already
// correct on the first render.

import { useSession } from '@/hooks';
import { LandingPage } from '@/features/landing';
import { HomePage } from './HomePage';

export function HomeOrLanding() {
  const { isAuthenticated } = useSession();
  return isAuthenticated ? <HomePage /> : <LandingPage />;
}
